import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { OrderBillingSettingsPayload } from "~/modules/billing/utils/billingSettingsFormUtils.ts";
import type {
	CreateOrderData,
	Order,
	OrderWithBillingSettings,
	UpdateOrderData,
} from "~/modules/project/api/order/orderTypes.ts";


type CreateOrderParamsType = {
	projectId: string;
	orderData: CreateOrderData;
}

export function indexProjectsOrders(projectId: string): AxiosApiResponsePromise<OrderWithBillingSettings[]> {
	return axiosApi.get(`projects/${projectId}/orders`);
}

export function createOrder({
	projectId,
	orderData,
}: CreateOrderParamsType): AxiosApiResponsePromise<Order> {
	return axiosApi.post(`/projects/${projectId}/orders`, { ...orderData });
}

export function updateOrder({ projectId, orderId, orderData }: {
	projectId: string,
	orderId: string,
	orderData: UpdateOrderData
}): AxiosApiResponsePromise<Order> {
	return axiosApi.put(`/projects/${projectId}/orders/${orderId}`, { ...orderData });
}

export function deleteOrder({ projectId, orderId }: {
	projectId: string,
	orderId: string
}): AxiosApiResponsePromise<void> {
	return axiosApi.delete(`/projects/${projectId}/orders/${orderId}`);
}

export function updateOrderBillingSettings({ projectId, orderId, billingSettingsData }: {
	projectId: string,
	orderId: string,
	billingSettingsData: OrderBillingSettingsPayload
}): AxiosApiResponsePromise<OrderWithBillingSettings> {
	return axiosApi.put(`/projects/${projectId}/orders/${orderId}/billing-settings`, billingSettingsData);
}
